import * as React from "react";
export interface Props {
    adminemail:string;
  }
export default class LicLimitExced extends React.Component<Props> {
  public render() {
    return (
      <div id="dvlicLimitExcedMessage" className="mesagecontainer">
        <p className="licheading"> MIPA License limit reached! </p>
        <p>
          Your organization has exceeded the number of purchased licenses.
           MIPA license manager can reassign a license or contact iGlobe to purchase additional licenses.
          <li><b>Starter pack</b>  of 5 users. (5 x 4 x 12 month = 240,- )
                         <b> This is our minimum order</b></li>
                         <li>Up to 50 users, US $4,- or Euro 4,- per user per month based on a yearly subscription and <b>a minimum of 5 user per order</b>.</li>
                        <li>From 50 users, US $3,- or Euro 3,- per user per month based on a yearly subscription.</li>
                        <li>Over 500, get a quote</li>
          <li>Legal information regarding MIPA - MIPA license agreement</li>
        </p>
        <p>
          <span>Send an email to</span>{" "}
          <a href="mailto:sales@iglobe.dk">sales@iglobe.dk</a> with
          <ol>
            <li>The required number of users</li>
            <li>
              Invoicing information, contact name and email, company name,
              address, postal code, city, country if possible vat number. you
              will receive a paypal invoice that you can pay using your credit
              card.
            </li>
          </ol>
        </p>
        <p>
          We will activate your account immediately when we received payment
          from you, making it possible for your organization to continue using
          the Add-in.
        </p>
        <p style={{fontWeight:'bold'}}>If you have admin access please visit mange users tab and change users</p>

        <p>Should you have any questions please feel free to <a href="mailto:sales@iglobe.dk" target="_blank" rel="noopener">contact us</a>. We can also offer you a demo or assist you in the implementation. As it is a simple product, we believe it will not take more than just 30 min. <a href="https://outlook.office365.com/owa/calendar/iGlobeOffice365@iglobe.dk/bookings/" target="_blank" rel="noopener">Book us now</a></p>
      </div>
    );
  }
}
